export default __webpack_public_path__ + "static/media/HirkaArcelik.0e9470af.jpg";